import React from 'react'

const Faq = () =>{
    return (
        <h1 className="text-center">Coming Soon</h1>
    )
}

export default Faq